import { type Time } from '@discover-data/stores/restaurant/model/times/model';
import { useStoreActions, useStoreState } from '@discover-data/stores/restaurant/hooks';
import useOptions from '../useOptions';
import isValidTime from '../isValid';
import useStartTimeQueryState from './useStartTimeQueryState';

export default function useStartTime(): [Time, (newTime: number | null) => Promise<void>] {
  const storeMode = useStoreState((state) => state.mode);
  const storeValue = useStoreState((state) => state.times.start);
  const setStoreValue = useStoreActions((actions) => actions.times.setStart);
  const options = useOptions();

  const [, setRouterValue] = useStartTimeQueryState();

  async function set(newTime: number | null) {
    if (isValidTime(newTime, options)) {
      setStoreValue(newTime);

      await setRouterValue(newTime);
    }
  }

  return [storeValue, set];
}
